import React, { PureComponent } from "react";
import { Grid } from "@mui/material";
import { PieChart, Pie, Cell } from "recharts";
import styles from "./Explore_2_3_img.module.css";
import Typography from "@mui/material/Typography";

const data = [
  { name: "學校內創業教育", value: 4, color: "#FFC41F" },
  { name: "過去就學/工作累積的專業或產業經驗", value: 50, color: "#FFB82E" },
  { name: "工作以外的個人嗜好及研究", value: 31, color: "#FFF8E0" },
  { name: "政府創業輔導資源", value: 8, color: "#FFEBA3" },
  { name: "家庭背景", value: 7, color: "#FDD975" },
];

const renderCustomizedLabel = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, percent } = props;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.35;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="black"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      //  style="font-weight: 300;"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default class Example extends PureComponent {
  // const classes = useStyles();
  static demoUrl =
    "https://codesandbox.io/s/pie-chart-with-padding-angle-7ux0o";

  render() {
    return (
      <Grid container>
        <Grid item xs={6}>
          <PieChart
            width={400}
            height={500}
            onMouseEnter={this.onPieEnter}
            className={styles.PieBox}
          >
            <Pie
              data={data}
              cx={120}
              cy={300}
              labelLine={false}
              label={renderCustomizedLabel}
              innerRadius={60}
              outerRadius={120}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </Grid>
        <Grid item xs={6} className={styles.NameBox}>
          {data.map((entry, index) => (
            <Grid container>
              <Grid
                item
                xs={1}
                margin={1}
                style={{
                  width: "30px",
                  height: "30px",
                  backgroundColor: entry.color,
                }}
              ></Grid>
              <Grid item xs={10}>
                <Typography key={`cell-${index}`} variant="h8">
                  {entry.name + "\n"}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  }
}
